import { httpGet, httpPut, httpPost, httpDelete } from "./helpers";

export default {
    activateUser: (id) => httpPut(`user/${id}/activate`),
    createUser: request => httpPost("user", request),
    checkUserAdministrator: () => httpGet("user/permissions/administrator"),
    deleteUser: (id) => httpDelete(`user/${id}`),
    getAllUsers: () => httpGet("user"),
    getUser: (id) => httpGet(`user/${id}`),
    getAllUsersCount: () => httpGet("user/count"),
    getCurrentUser: () => httpGet("user/current"),
    getCurrentUserData: () => httpGet("user/data"),
    inactivateUser: (id) => httpPut(`user/${id}/inactivate`),
    updateUser: (id, request) => httpPut(`user/${id}`, request),
};